export const defaultChartOpts = {
  allowDecimals: false,
  domain: [0, 'dataMax']
}
